import { useQuery } from "@tanstack/react-query";
import { fetchInvoices } from "@/api/v1-jwt/invoice/invoice";
import { useAuth } from "@/providers/auth";

export const useInvoices = ({
  queryFn,
  queryKey,
  enabled,
  fromContactId,
  filters = {},
  ...rest
} = {}) => {
  const { cognitoId, clientId, userRole } = useAuth();

  const userId =
    userRole === "admin" || userRole === "auth_user" ? clientId : cognitoId;
  const isEnabled = !!userId && enabled !== false;

  const type = JSON.parse(localStorage.getItem("UserRole")) || "client";
  const id = fromContactId || userId;

  return useQuery({
    queryKey: ["invoices", type, id, filters],
    queryFn: async () => {
      return await fetchInvoices({
        id,
        type,
        filters,
      });
    },
    enabled: isEnabled,
    staleTime: 5 * 60 * 1000,
    ...rest,
  });
};
